import React from 'react';
import { Form, TextBox, TextAreaBox, IntBox, Switch, CheckBox, UrlBox, CurrencyBox, EmailBox } from 'fw/forms';
import {
	Address,
	PhoneBox,
	DocumentUpload,
	BusinessAcquirementCombo,
	BusinessOwnershipCombo,
	BusinessPremisesCombo,
	GeographicMarketCombo
} from 'areas/shared/controls';
import { Col, FormGroup, Row, Button, Glyphicon } from 'react-bootstrap';
import { Label, ActionButton, Tooltip } from 'fw/components';
import { ContentBody, VeteranAppIdHeader } from 'areas/shared/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import * as FormManager from 'fw/forms/form/FormManager';
import OnlinePaymentInfoPopUp from './OnlinePaymentInfoPopUp';
import PreQualificationInfoPopUp from './PreQualificationInfoPopUp';
import { TooltipCode } from 'areas/shared/consts';
import SystemAPI from 'fw/system/API';

// eslint-disable-next-line
var yearItems = {};

class CompanyInfo extends React.Component {

    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        this.buildYearItems();
        return {
            form: this.props.stepData,
            showOnlinePaymentInfoPopUp: false,
            showPreQualificationInfoPopUp: false,
            tooltips: this.props.stepInfo.tooltips
        };
    }

    onOnlinePaymentInfoClose = () => {
        this.setState({
            showOnlinePaymentInfoPopUp: false
        });
    }

    onOnlinePaymentInfoClick = () => {

        if (this.state.form.onlinePayment !== null || this.state.form.paymentInfoStorageToken === null) {
            this.setState({
                showOnlinePaymentInfoPopUp: true
            });
        }
        else if (this.state.form.paymentInfoStorageToken !== null) {
            new SystemAPI().download({
                storageToken: this.state.form.paymentInfoStorageToken,
                fileName: this.state.form.paymentInfoFileName
            });
        }
    }

    onPreQualificationInfoClose = () => {
        this.setState({
            showPreQualificationInfoPopUp: false
        });
    }

    onPreQualificationInfoClick = () => {
        this.setState({
            showPreQualificationInfoPopUp: true
        });
    }

    updatePostData = (form, dirty) => {
        this.checkBlankFields(form);
        this.setState({ form });
        this.props.onStepChange(form);

        if (dirty === true)
            FormManager.dirt(this._form);
    }

    checkBlankFields = (form) => {
        //check DBA fields
        if (!form.dba)
            form.vobDba = [];
        else {
            if (form.vobDba.length === 0)
                this.addAnotherDba();
        }
        //check BusinessOwnershipExplanation
        if (form.businessOwnershipId !== 6) {
            form.businessOwnershipExplanation = null;
            form.businessOwnershipStorageToken = null;
            form.businessOwnershipFileName = null;
        }

        //check BlankBusinessAcquirementExplanation
        if (form.businessAcquirementId !== 5)
            form.businessAcquirementExplanation = null;

        //check MailingAddress Fields
        if (form.sameMailingAddress !== this.state.form.sameMailingAddress)
            form.mailingAddress = null;
    }

    buildYearItems() {
        var yearStart = 1900;
        var yearEnd = new Date().getFullYear();
        var years = [];

        years.push(0);
        while (yearStart <= yearEnd) {
            years.push(yearEnd--);
        }

        yearItems = years.map((item) => { return { label: item, value: item } });
    }

    componentDidMount() {
        // Add a phone control to be filled
        if (this.state.form.phones.length === 0)
            this.handleAddPhone();
        if (this.state.form.grossRevenueDocuments !== undefined && this.state.form.grossRevenueDocuments.length === 0)
            this.addGrossRevenueDocument();
    }

    handleBusinessOwnershipUploadChange = (file) => {
        let form = this.state.form;
        form.businessOwnershipStorageToken = file.storageToken;
        form.businessOwnershipFileName = file.fileName;

        this.updatePostData(form, true);
    }

    handleAddPhone = () => {
        const phones = this.state.form.phones;

        phones.push({
            phoneTypeCode: "MOBILE",
            number: "",
            extension: "",
            phoneId: -Math.abs(Date.now() | 0)
        });

        this.setState({
            phones
        });
    }

    handleRemovePhone = (i) => {
        const phones = this.state.form.phones;

        phones[i].number = "";
        phones.splice(i, 1);

        this.setState({ form: { ...this.state.form, phones } })
    }

    handlePhoneChange = (v, i) => {
        const phones = this.state.form.phones;

        phones[i] = v;

        this.setState({ form: { ...this.state.form, phones } })
    }

    renderPhones = () => {
        return this.state.form.phones.map((p, i) =>
            <div key={p.phoneId} className="form-inline" >
                <PhoneBox
                    value={p}
                    showExtension
                    onChange={(v) => this.handlePhoneChange(v, i)}
                    required={i === 0 ? "required" : ""}
                />
                <Button
                    bsStyle="link"
                    title="Remove Phone"
                    onClick={() => this.handleRemovePhone(i)}><FontAwesomeIcon icon={faTimes} /></Button>
            </div>
        );
    }

    addAnotherDba = () => {
        let form = this.state.form;
        form.vobDba.push({});

        this.updatePostData(form);
    }

    handleOtherDbaRemove = (index) => {
        let form = this.state.form;
        form.vobDba[index].name = "";
    };

    handleUploadDbaDocumentChange = (file, index) => {
        let form = this.state.form;
        form.vobDba[index].storageToken = file.storageToken;
        form.vobDba[index].fileName = file.fileName;

        this.updatePostData(form, true);
    };

    handleDbaNameChange = (value, index) => {
        let form = this.state.form;
        form.vobDba[index].name = value;

        this.updatePostData(form, true);
    };

    handleRemoveDbaDocument = (i) => {
        let form = this.state.form;
        form.vobDba.splice(i, 1);

        this.updatePostData(form, true);
    };

    renderDbaFiles = () => {
        return this.state.form.vobDba.map((item, index) => (
            <Row key={index} style={{ marginBottom: 10 }}>
                <Col md={1} style={{ marginTop: 5, textAlign: "left", marginLeft: 0, paddingLeft: 0 }}>
                    {index > 0 ?
                        <div>
							<Button type="button" bsStyle="link" onClick={() => this.handleRemoveDbaDocument(index)} title="Remove Financial Document">
                                <FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
							</Button>
                        </div>
                        : null}
                </Col>
                <Col md={11}>
                    <DocumentUpload
                        disabled={this.props.stepInfo.isRenewal}
                        storageToken={item.storageToken}
                        fileName={item.fileName}
                        onChange={file => this.handleUploadDbaDocumentChange(file, index)}
                        onRemove={() => this.handleOtherDbaRemove(index)}
                        wrapFileNameLength={30}
                    />
                    <Label htmlFor={`dbaName_${index}`} required>DBA Name</Label>
                    <TextAreaBox
                        formControl={false}
                        name={`dbaName_${index}`}
                        disabled={this.props.stepInfo.isRenewal}
                        value={item.name}
                        placeholder='Please enter other Business Name'
                        maxLength={50}
                        onChange={value => this.handleDbaNameChange(value, index)}
                    />
                </Col>
            </Row>
        ));
    };

    addGrossRevenueDocument = () => {
        let form = this.state.form;

        form.grossRevenueDocuments.push({
            vobGrossRevenueDocumentId: -Math.abs(Date.now() | 0)
        });

        this.setState({ form: form });
    };

    handleUploadGrossRevenueDocumentChange = (file, index) => {
        let form = this.state.form;

        form.grossRevenueDocuments[index].storageToken = file.storageToken;
        form.grossRevenueDocuments[index].fileName = file.fileName;

        this.setState({ form: form });
    };

    handleRemoveGrossRevenueDocument = (i) => {
        let form = this.state.form;

        form.grossRevenueDocuments.splice(i, 1);

        this.setState({ form: form });
    }

    renderGrossRevenueDocuments = () => {
        return this.state.form.grossRevenueDocuments.map((item, index) => (
            <Row key={item.vobGrossRevenueDocumentId}>
                <Col md={11}>
                    <DocumentUpload
                        storageToken={item.storageToken}
                        fileName={item.fileName}
                        onChange={file => this.handleUploadGrossRevenueDocumentChange(file, index)}
                    />
                </Col>
                {index > 0 ?
                    <Col md={1} style={{ marginTop: 5, marginLeft: -15, paddingLeft: 0, textAlign: "left" }}>
						<Button type="button" bsStyle="link" onClick={() => this.handleRemoveGrossRevenueDocument(index)} title="Remove Gross Revenue Supporting Document">
                            <FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
						</Button>
                    </Col>
                    : null}
            </Row>
        ));
    };

    setTip = (property) => {
        const tooltip = this.state.tooltips.find(t => t.code === property)
        return tooltip !== undefined ? tooltip.tip : null
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    render() {

        var me = this;
        return (
            <Form
                onChange={this.updatePostData}
                values={this.state.form}
                unsavedChangesWarning={true}
                disabled={this.props.stepInfo.readonly || this.props.stepInfo.isRenewal}
                ref={(form) => { this._form = form }}>
                <div>
                    <ContentBody>
                        <Row>
                            <Col md={12}>
                                <Row>
                                    <Col md={12}>
                                        <h3 style={{ position: 'relative' }}>
                                            Company Information – <small>Please submit all required Company Information</small>
                                            <VeteranAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.stepInfo.daysOpen} />
                                        </h3>
                                        <hr />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={5}>
                                        <FormGroup>
                                            <Label htmlFor="vobName" tip={this.setTip(TooltipCode.COMPANY.COMPANYNAME)} required>
                                                Company Name
                                            </Label>
                                            <TextBox name="vobName" placeholder="Company Name" maxLength={128} ref={(c) => { this.focusControl = c; }} />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label htmlFor="vobFein" tip={this.setTip(TooltipCode.COMPANY.COMPANYFEIN)} required>
                                                Company FEIN/EIN
                                            </Label>
                                            <TextBox name="vobFein" maxLength={10} required disabled />
                                        </FormGroup>
                                        {this.state.form.phones != null && this.state.form.phones.length > 0 &&
                                            <FormGroup>
                                                <Label htmlFor="phoneNumber" tip={this.setTip(TooltipCode.COMPANY.PHONENUMBER)} required>Phone Number(s)</Label>
                                                {this.renderPhones()}
                                            </FormGroup>
                                        }
                                        {this.state.form.phones != null && this.state.form.phones.length < 5 &&

                                            <Button bsStyle="default" bsSize="xsmall" className="pull-right" onClick={this.handleAddPhone}>Add Phone<Glyphicon glyph="plus" style={{ marginLeft: 10 }} /></Button>
                                        }
                                        <FormGroup style={{ marginTop: "35px" }}>
                                            <Label htmlFor="website" tip={this.setTip(TooltipCode.COMPANY.WEBSITE)}>Company Website</Label>
                                            <UrlBox
                                                name='website'
                                                placeholder='Company Website'
                                                maxLength={200}
                                            />
                                        </FormGroup>
                                        <FormGroup style={{ marginTop: "35px" }}>
                                            <Label htmlFor="email" tip={this.setTip(TooltipCode.COMPANY.EMAIL)} required>Company Email</Label>
                                            <EmailBox required 
                                                name="email"
                                                placeholder='Company Email'
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label htmlFor="dba" tip={this.setTip(TooltipCode.COMPANY.DOINGBUSINESS)}>
                                                Does your Business operate with a “Doing Business As” (DBA) name?
                                            </Label>
                                            <Row>
                                                <Col md={3}>
                                                    <Switch name="dba" labelLeft="No" labelRight="Yes" bsStyle="primary" />
                                                </Col>
                                                <Col md={9}>
                                                    {this.state.form !== null && this.state.form.dba ?
                                                        (
                                                            <React.Fragment>
                                                                <FormGroup>
                                                                    {this.state.form.vobDba != null && this.state.form.vobDba.length > 0 && this.renderDbaFiles()}
                                                                </FormGroup>
                                                                {this.state.form.vobDba != null && this.state.form.vobDba.length < 5 && (
                                                                    <Button bsStyle="default" bsSize="xsmall" className="pull-right" onClick={this.addAnotherDba}>Add DBA<Glyphicon glyph="plus" style={{ marginLeft: 10 }} /></Button>
                                                                )}
                                                            </React.Fragment>)
                                                        : null}
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                    </Col>
                                    <Col md={1}></Col>
                                    <Col md={5}>
                                        <FormGroup>
                                            <Label htmlFor="businessOwnershipId" tip={this.setTip(TooltipCode.COMPANY.BUSINESSOWNERSHIP)} required>Business Ownership</Label>
                                            <BusinessOwnershipCombo name="businessOwnershipId" placeholder="Business Ownership" />
                                        </FormGroup>
                                        {this.state.form !== null && this.state.form.businessOwnershipId === 6 ? // Change this to ask for 'Other'
                                            (
                                                <React.Fragment>
                                                    <TextAreaBox name="businessOwnershipExplanation" maxLength={200} placeholder="Please explain using this text field, and upload a document of explanation below" />
                                                    <DocumentUpload
                                                        storageToken={this.state.form.businessOwnershipStorageToken}
                                                        fileName={this.state.form.businessOwnershipFileName}
                                                        onChange={this.handleBusinessOwnershipUploadChange} />
                                                </React.Fragment>)
                                            : null}
                                        <FormGroup>
                                            <Label htmlFor="geographicMarketId" tip={this.setTip(TooltipCode.COMPANY.GEOGRAPHICMARKET)} required>Business Geographic Market</Label>
                                            <GeographicMarketCombo name="geographicMarketId" placeholder="Business Geographic Market" />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label htmlFor="businessPremisesId" tip={this.setTip(TooltipCode.COMPANY.BUSINESSPREMISES)} required>
                                                Type of Business Premises
                                            </Label>
                                            <BusinessPremisesCombo name='businessPremisesId' placeholder="Type of Business Premises" />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label htmlFor="businessAcquirementId" tip={this.setTip(TooltipCode.COMPANY.BUSINESSACQUIREMENT)} required>How was the Business Acquired?</Label>
                                            <BusinessAcquirementCombo name="businessAcquirementId" placeholder="How was the Business Acquired?" />
                                        </FormGroup>
                                        {this.state.form !== null && this.state.form.businessAcquirementId === 5 ? // Change this to ask for 'Other'
                                            (
                                                <React.Fragment>
                                                    <TextAreaBox name="businessAcquirementExplanation" maxLength={200} />
                                                </React.Fragment>)
                                            : null}
                                        <FormGroup>
                                            <Label required htmlFor="yearBusinessFormed" tip={this.setTip(TooltipCode.COMPANY.YEARBUSINESSFORMED)}>
                                                What year did your company begin?
                                            </Label>
                                            <TextBox required name="yearBusinessFormed" placeholder="What year did your company begin?" />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label required htmlFor="yearVeteranBusiness" tip={this.setTip(TooltipCode.COMPANY.YEARVETERANCOMPANY)}>
                                                What year did the veteran(s) become the controlling owner?
                                            </Label>
                                            <TextBox required name="yearVeteranBusiness" placeholder="What year did the veteran(s) become the controlling owner?" />
                                        </FormGroup>
                                    </Col>
                                    <Col md={1}>
                                        <ActionButton id='btnPrint' onClick={this.onOnlinePaymentInfoClick} icon='info-sign'>
                                            Payment
                                            </ActionButton>
                                        <OnlinePaymentInfoPopUp
                                            certificationId={this.state.form.certificationId}
                                            visible={this.state.showOnlinePaymentInfoPopUp}
                                            onClose={this.onOnlinePaymentInfoClose}
                                            onlinePayment={this.state.form.onlinePayment} />
                                        <ActionButton id='btnPrint' onClick={this.onPreQualificationInfoClick} icon='info-sign'>
                                            Prequal
                                            </ActionButton>
                                        <PreQualificationInfoPopUp
                                            certificationId={this.state.form.certificationId}
                                            visible={this.state.showPreQualificationInfoPopUp}
                                            onClose={this.onPreQualificationInfoClose}
                                            prequalificationInfo=
                                            {{
                                                questionnaire: this.state.form.questionnaire,
                                                grossRevenue1Year: this.state.form.grossRevenue1Year,
                                                grossRevenue1Amount: this.state.form.grossRevenue1Amount,
                                                grossRevenue2Year: this.state.form.grossRevenue2Year,
                                                grossRevenue2Amount: this.state.form.grossRevenue2Amount
                                            }} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <Row>
                                            <Col md={12}>
                                                <h3>Company Address</h3>
                                                <hr />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Address name="businessAddress" required />
                                                </FormGroup>
                                                <CheckBox name="sameMailingAddress" label="Mailing Address same as Company Address" />
                                            </Col>
                                        </Row>
                                        {this.state.form !== null && !this.state.form.sameMailingAddress ?
                                            (
                                                <React.Fragment>
                                                    <Row>
                                                        <Col md={12}>
                                                            <h3>Mailing Address</h3>
                                                            <hr />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md={10}>
                                                            <FormGroup>
                                                                <Address name="mailingAddress" required />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </React.Fragment>)
                                            : null}
                                        <Row>
                                            <Col md={12}>
                                                <br />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6}>
                                        <Row>
                                            <Col md={12}>
                                                <h3>Company Sales</h3>
                                                <hr />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={10}>
                                                <Row>
                                                    <Col md={12}>
                                                        <Label> Enter Gross Revenue for the last 2 years </Label>
                                                    </Col>
                                                </Row>
                                                <Row><Col>&nbsp;</Col></Row>
                                                <Row>
                                                    <Col md={3}>
                                                        <Label> From Prequal </Label>
                                                    </Col>
                                                    <Col md={3}>
                                                        <IntBox
                                                            disabled={true}
                                                            name="grossRevenue1Year"
                                                            maxLength={4} />
                                                    </Col>
                                                    <Col md={5}>
                                                        <CurrencyBox
                                                            disabled={true}
                                                            name="grossRevenue1Amount"
                                                            positiveNumbersOnly
                                                            maxLength={15}
                                                            precision={0} />
                                                    </Col>
                                                    <Col md={1} style={{ margin: 0, padding: 0 }}>
                                                        <Tooltip tip={me.setTip(TooltipCode.COMPANY.GROSSREVENUEFIRST)}
                                                            placement="left" />
                                                    </Col>
                                                </Row>
                                                <Row><Col>&nbsp;</Col></Row>
                                                <Row>
                                                    <Col md={3}>
                                                        <Label> 2nd Year </Label>
                                                    </Col>
                                                    <Col md={3}>
                                                        <FormGroup>
                                                            <IntBox
                                                                disabled={true}
                                                                name="grossRevenue2Year"
                                                                placeholder="Year"
                                                                maxLength={4} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={5}>
                                                        <FormGroup>
                                                            <CurrencyBox
                                                                disabled={true}
                                                                name="grossRevenue2Amount"
                                                                placeholder='Please provide whole numbers'
                                                                positiveNumbersOnly
                                                                maxLength={15}
                                                                precision={0} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={1} style={{ margin: 0, padding: 0 }}>
                                                        <Tooltip tip={me.setTip(TooltipCode.COMPANY.GROSSREVENUESECOND)}
                                                            placement="left" />
                                                    </Col>
                                                </Row>
                                                <Row><Col>&nbsp;</Col></Row>
                                                <Row>
                                                    <Col md={2}></Col>
                                                    <Col md={4}>
                                                        <Label> Application Fee </Label>
                                                    </Col>
                                                    <Col md={5}>
                                                        <CurrencyBox
                                                            name="applicationFee"
                                                            disabled={true}
                                                            positiveNumbersOnly
                                                            maxLength={10}
                                                            precision={2} />
                                                    </Col>
                                                    <Col md={1} style={{ margin: 0, padding: 0 }}>
                                                        <Tooltip tip={me.setTip(TooltipCode.COMPANY.APPFEEPAID)}
                                                            placement="left" />
                                                    </Col>
                                                </Row>
												<Row><Col>&nbsp;</Col></Row>
												<Row>
													<Col md={2}></Col>
													<Col md={4}>
														<Label> Discount Applied </Label>
													</Col>
													<Col md={5}>
														<CurrencyBox
															name="discountAmount"
															disabled={true}
															positiveNumbersOnly
															maxLength={10}
															precision={2} />
													</Col>
												</Row>
												<Row><Col>&nbsp;</Col></Row>
												<Row>
													<Col md={2}></Col>
													<Col md={4}>
														<Label> Payment Amount </Label>
													</Col>
													<Col md={5}>
														<CurrencyBox
															name="paymentAmount"
															disabled={true}
															positiveNumbersOnly
															maxLength={10}
															precision={2} />
													</Col>
												</Row>
                                                <Row><Col>&nbsp;</Col></Row>
                                                <Row>
                                                    <Col md={12}>
                                                        <Label htmlFor="grossRevenueDocumentUpload" tip={this.setTip(TooltipCode.COMPANY.GROSSREVENUESUPDOC)}>Gross Revenue Supporting Documents</Label>
                                                        {this.state.form.grossRevenueDocuments != null &&
                                                            this.state.form.grossRevenueDocuments.length > 0 && (
                                                                <React.Fragment>
                                                                    {this.renderGrossRevenueDocuments()}
                                                                    {(this.state.form.grossRevenueDocuments == null || this.state.form.grossRevenueDocuments.length < 5) &&
																		<Button type="button" bsStyle="link" onClick={this.addGrossRevenueDocument}>
                                                                            Add another Gross Revenue Supporting Document
																		</Button>
																	}
                                                                </React.Fragment>
                                                            )
                                                        }
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </ContentBody>
                </div>
            </Form>)
    }
}

export default CompanyInfo;



// WEBPACK FOOTER //
// ./src/areas/certification/steps/companyInfo/CompanyInfo.js